import { DataSource } from "../../Data/DataSource";
import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { ComboBox, ComboBoxPropertyValues, IComboBox } from "./ComboBox";
import { NAMESPACE } from "./_Namespace";

export type ComboBoxYesNoPropertyValues =
    ComboBoxPropertyValues
    & {
    };

export type ComboBoxYesNoProperties = {
    [name in keyof ComboBoxYesNoPropertyValues]: Property<ComboBoxYesNoPropertyValues[name]>
};

export interface IComboBoxYesNo extends IComboBox, ComboBoxYesNoProperties
{
}

export class ComboBoxYesNo extends ComboBox implements IComboBoxYesNo
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ComboBoxYesNo";
    public static override className = "ComboBoxYesNo";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ComboBoxYesNoPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                listDataSource: new DataSource({
                    data: [
                        { value: false, description: "No" },
                        { value: true, description: "Yes" }
                    ]
                })
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ComboBoxYesNoPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #endregion
}

